import page from "page";
import { currentPath } from "./global-state";
import { getSession } from "./session";
import { clearThrottledCallStore } from "./ui/throttle";
import * as IntervalManager from "./interval-manager";
import el from "@cypherpotato/el";
import { pageQuery } from "./util";

export function map(url, render) {
    page(url, async (ctx) => {

        ctx.session = getSession();
        ctx.query = ctx.querystring && Object.fromEntries([...new URLSearchParams(ctx.querystring).entries()]) || {};

        IntervalManager.clearAllIntervals();
        el.state.clearAllPoolingStates();

        const [rendered] = await Promise.all([
            render(ctx)
        ]);

        window.scrollTo({ top: 0 });

        currentPath.value = url;

        if (rendered instanceof Node) {
            app.innerHTML = "";
            app.appendChild(rendered);
        }

        void app.offsetHeight;

        delete window._dragHandler;
        clearThrottledCallStore();
    });
}